import React from 'react'
import { useTranslation } from "react-i18next";
import { ExpirationGap, IsExpirationLessThan } from '../../../api/Inventory/Entities/InventoryEntities';

export default function ExpirationWarning({ moveItem }) {
    const { t } = useTranslation();
    const isExpirationLessThan = (itemParam, monthsGap) =>
        new Date(itemParam.release.expirationDate) <= new Date(new Date().setMonth(new Date().getMonth() + monthsGap))

    const isLaboratoryKit = moveItem.item?.type === "LaboratoryKit";
    const expirationGapOneMonth = 1;

    return (<div style={{ fontSize: '1.05rem', color: "#fff", letterSpacing: '1.5px' }}>
        {(isLaboratoryKit && isExpirationLessThan(moveItem, expirationGapOneMonth) && <strong style={{ background: "#ca6e6e", padding: ".3rem .7rem", borderRadius: "4px" }}>{t('inventory.dispense.warnings.expiresInLessThanOneMonth')}</strong>
            || isExpirationLessThan(moveItem, ExpirationGap.Critical) && <strong style={{ background: "#ca6e6e", padding: ".3rem .7rem", borderRadius: "4px" }}>{t('inventory.dispense.warnings.expiresInLessThanTwoMonths')}</strong>
            || isExpirationLessThan(moveItem, ExpirationGap.Warning) && <strong style={{ background: "#ffa534", padding: ".3rem .7rem", borderRadius: "4px" }}>{t('inventory.dispense.warnings.expiresInLessThanSixMonth')}</strong>)}
    </div>)
}
export function ReleaseExpirationWarning({ release }) {
    const { t } = useTranslation();

    return (<div style={{ fontSize: '1.05rem', color: "#fff", letterSpacing: '1.5px' }}>
        {(IsExpirationLessThan(release, ExpirationGap.Critical) && <strong style={{ background: "#ca6e6e", padding: ".3rem .7rem", borderRadius: "4px" }}>{t('inventory.dispense.warnings.expiresInLessThanTwoMonths')}</strong>
            || IsExpirationLessThan(release, ExpirationGap.Warning) && <strong style={{ background: "#ffa534", padding: ".3rem .7rem", borderRadius: "4px" }}>{t('inventory.dispense.warnings.expiresInLessThanSixMonth')}</strong>)}
    </div>)
}
